import { Checkbox } from '@orbind/ui'

/**
 * Escolha de visibilidade dos Itens de Trabalho criados num quadro
 * (SPEC-20261007-0934-visibilidade-padrao-do-quadro). A mesma na criação e na edição do quadro — duas
 * telas com o mesmo par de opções desenhado duas vezes acabariam divergindo.
 */
export function VisibilidadeDosNovosItens({
  privados,
  onChange,
}: {
  privados: boolean
  onChange: (privados: boolean) => void
}) {
  return (
    <div className="kb-visib" role="radiogroup" aria-label="Visibilidade dos itens criados no quadro">
      <button
        type="button"
        role="radio"
        aria-checked={!privados}
        className={`kb-visib__op${privados ? '' : ' kb-visib__op--on'}`}
        onClick={() => onChange(false)}
      >
        <i className="fas fa-globe" aria-hidden />
        <span>
          <strong>Públicos</strong>
          <small>Todos do workspace veem os itens criados aqui.</small>
        </span>
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={privados}
        className={`kb-visib__op${privados ? ' kb-visib__op--on' : ''}`}
        onClick={() => onChange(true)}
      >
        <i className="fas fa-lock" aria-hidden />
        <span>
          <strong>Privados</strong>
          <small>Só o responsável, os membros e o administrador.</small>
        </span>
      </button>
    </div>
  )
}

/**
 * "Itens criados somente para este quadro" (SPEC-20261007-1538-quadros-do-item): ligado, o
 * campo Quadros de cada item criado aqui já nasce com este quadro — e o item
 * aparece só nele.
 */
export function SomenteNesteQuadro({
  exclusivos,
  onChange,
}: {
  exclusivos: boolean
  onChange: (exclusivos: boolean) => void
}) {
  return (
    <Checkbox
      label="Itens criados aqui aparecem somente neste quadro"
      checked={exclusivos}
      onChange={(e) => onChange(e.target.checked)}
    />
  )
}
